import { AfterViewInit, Directive, ElementRef, HostListener, Input, OnDestroy, OnInit } from '@angular/core';
import { NgbDropdownMenu, NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';

@Directive({
  selector: '[txCheckOverflow]',
  exportAs: 'txCheckOverflow',
})
export class CheckOverflowDirective implements AfterViewInit, OnDestroy {
  isOverflowing = false;
  private visibilitySub: Subscription | undefined;
  @Input() parentPopover: NgbDropdownMenu | undefined;

  constructor(private el: ElementRef) {}

  ngAfterViewInit(): void {
    if (this.parentPopover) {
      this.visibilitySub = this.parentPopover.dropdown.openChange.subscribe((openOrClosed) => {
        console.log('ELEMENT.scrollWidth---SUBSCRIBE');
        this.checkOverflow();
      });
    }
  }

  ngOnDestroy(): void {
    this.visibilitySub?.unsubscribe();
  }

  @HostListener('window:resize')
  onResize(): void {
    console.log('ELEMENT.scrollWidth---RESIZE');
    this.checkOverflow();
  }

  private checkOverflow(): void {
    const element = this.el.nativeElement;
    this.isOverflowing = element.scrollWidth > element.clientWidth;
    console.log('element.scrollWidth', this.isOverflowing, element, element.scrollWidth, element.clientWidth);
  }
}
